import at from '../../actionTypes'
import respond from './utilities/respond'

export const fetchFatalError = (error, ...rest) => respond(at.FETCH_ERROR, { error, ...rest })
export const fetchWarning = (error, ...rest) => respond(at.FETCH_WARN, { error, ...rest })

//	Global fetch fatal error action
const fetchActions = {
	fetchFatalError,
	fetchWarning
}

export default fetchActions



// WEBPACK FOOTER //
// ./src/redux/actionCreators/old_actions/fetchActions.js